// Checkout payments allowed in the following countries
// France, India, Spain, South Africa, Sweden, UAE, Singapore, Romania, Malaysia

export const CHECKOUT_ALLOWED_COUNTRIES = [
    "FR",
    "ES",
    "ZA",
    "SE",
    "AE",
    "SG",
    "RO",
    "MY"
]